import { CloseIcon } from '@approvalmax/ui';
import { Button, Form, Grid, TextField } from '@approvalmax/ui/src/components';
import { validatorHelpers } from '@approvalmax/utils';
import { memo } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useClickAway } from 'react-use';
import { useRenameAmaxPayOpenBankingBankAccounts } from 'shared/data/webApp/v1';

import { messages } from './RenameBankAccountForm.messages';
import type { FormState, RenameBankAccountFormProps } from './RenameBankAccountForm.types';

export const RenameBankAccountForm = memo<RenameBankAccountFormProps>((props) => {
    const { onClose, id, nickname, rootRef } = props;

    const { companyId } = useParams<{ companyId: string }>();
    const { mutate, isLoading } = useRenameAmaxPayOpenBankingBankAccounts({
        onSuccess: () => {
            onClose();
        },
    });

    const form = useForm<FormState>({
        values: { nickname },
    });

    useClickAway(rootRef, () => {
        form.trigger().then((isValid) => {
            if (!isValid) {
                return;
            }

            const values = form.getValues();

            void mutate({ body: values, params: { path: { companyId, bankAccountId: id } } });
        });
    });

    const handleFormSubmit = (values: FormState) => {
        void mutate({ body: values, params: { path: { companyId, bankAccountId: id } } });
    };

    const handleSubmit = form.handleSubmit(handleFormSubmit);

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Grid gridTemplateColumns='auto repeat(2, max-content)' gap={8}>
                <TextField
                    initFocus
                    required
                    name='nickname'
                    placeholder={messages.bankAccountNickname}
                    maxLength={100}
                    validate={validatorHelpers.requiredString()}
                    // a hack to prevent show a hint block even though we do validation
                    hint=''
                />

                <Button color='midnight40' onClick={onClose}>
                    <CloseIcon size={16} />
                </Button>

                <Button color='blue80' type='submit' progress={isLoading}>
                    {messages.save}
                </Button>
            </Grid>
        </Form>
    );
});
